import { updateGeo } from 'shared/slices/jsonQuery';
import { TThunkAction } from 'shared/types/redux';
import { selectJsonQuery } from 'shared/selectors/jsonQuery';
import { addPolygonToJsonQuery } from 'shared/utils/jsonQuery';
import { IJsonQueryPolygon } from '../../../../packages/api-models/common/json_query';
import { updateTags } from 'shared/thunks/tags';
import { applyFilters } from 'shared/thunks/filters';

export const selectPolygon =
  (polygon: IJsonQueryPolygon): TThunkAction =>
  (dispatch, getState) => {
    const state = getState();
    const jsonQuery = selectJsonQuery(state);

    const newGeo = addPolygonToJsonQuery(jsonQuery, polygon);

    dispatch(updateGeo(newGeo));
    dispatch(updateTags());
    dispatch(applyFilters());
  };
